// TODO: don't show manage subscription if no subscription
// TODO: P1: update remaining credits when you open the page
import { Link } from 'react-router-dom';
// import Intercom from '@intercom/messenger-js-sdk';
// import { boot, update } from "@intercom/messenger-js-sdk";

import React, { useEffect, useState } from 'react';
import userStore from '../../../Stores/User';
import { useHistory } from 'react-router-dom';
import isUrl from 'is-url';
import { ReactComponent as Plus } from '../Icons/Plus.svg';
import { observer } from 'mobx-react';
import { mergeStyleSets, Modal } from '@fluentui/react';
import loadingIcon from '../../../Assets/loading.gif';
import { dryrunArticle, addArticleToUserPlaylist, updateUserTldrPreference, getUser, addUserFeed, getUserFeeds, getUserPlaylist } from '../../../audiblogsApi';
import { createStripeSessionAndRedirectToCheckout } from '../../../stripeLogic';
import '../index.scss';
import Chrome from '../../../Assets/chrome.svg';
import Edge from '../../../Assets/edge.svg';
import AppleStore from '../../../Assets/apple-app-store.svg';
import GoogleStore from '../../../Assets/google-play-store.svg';
import mixpanel from 'mixpanel-browser';
import { isMobile } from 'react-device-detect';
import PaidIcon from '@mui/icons-material/Paid';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
// import Intercom from '@intercom/messenger-js-sdk';
// import AppleIcon from "@material-ui/icons/Apple";
// import AndroidIcon from "@material-ui/icons/Android";
// import RssFeedIcon from "@material-ui/icons/RssFeed";
import {
  Apple as AppleIcon,
  Android as AndroidIcon,
  RssFeed as RssFeedIcon,

} from '@mui/icons-material';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import Upload from './Upload';
import isSupportedType from '../isSupportedType';
import { useBoolean } from '@fluentui/react-hooks';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import Checkout from '../../Checkout';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import { Switch, Tooltip } from '@mui/material';
import { isProPlan } from '../../../constants/plans';

const contentStyles = mergeStyleSets({
  container: {
    display: 'flex',
    flexFlow: 'column',
    backgroundColor: 'rgb(66 59 74)',
    width: '300px',
    padding: '10px',
    fontFamily: 'Cabin',
    fontSize: '18px',
    textAlign: 'center',
    minHeight: '108px',
    borderRadius: '14px',
  },
});

const AddArticle = observer(
  ({
    triggers,
    trackingId,
    selectionText,
    updateAddUrl: setArticleUrl,
    addUrl: articleUrl,
    addApp: app,
    addForce,
  }) => {
    const [shouldForceAdd, setShouldForceAdd] = useState(addForce);
    const [status, setStatus] = useState('');
    const [buttonMessage, setButtonMessage] = useState('Add Article');
    const [estimate, setEstimate] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showEmail, setShowEmail] = useState(false);
    const [modalContent, setModalContent] = useState(null);
    const [redirectTo, setRedirectTo] = useState('');
    const [isMounted, setIsMounted] = useState(true);
    const {
      user,
      idToken,
      isSignedIn,
      userFeedUrl,
      creditsHd,
      creditsSd,
    } = userStore;
    const [lowCreditTrigger, setLowCreditTrigger] = useState();
    const [
      isModalOpen,
      { setTrue: showModal, setFalse: hideModal },
    ] = useBoolean(false);
    const history = useHistory();
    const [addTldr, setAddTldr] = useState(false);
    const isProUser = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id 
      ? isProPlan(userStore.user.subscriptions.raw_subscriptions[0].plan.id)
      : false;
    const isPaidUser = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id
    const [monthlyConversions, setMonthlyConversions] = useState(0);

    useEffect(() => {
      if (user && articleUrl && user.user_id !== undefined) {
        if (isSupportedType(articleUrl, user.user_id)) showModal();
      }
    }, [articleUrl, user]);

    useEffect(() => {
      triggers.forEach((trigger) => {
        if (trigger.name === 'low_on_credits') {
          setLowCreditTrigger(true);
        }
      });
    }, [triggers]);

    useEffect(() => {
      // Fetch user data to get the current TLDR preference
      getUser(idToken)
        .then(response => {
          if (response.data) {
            setAddTldr(response.data.addTldr); // Set the toggle based on user data
          }
        })
        .catch(error => {
          console.error('Error fetching user data:', error);
        });
    }, [idToken]);

    useEffect(() => {
      // Add a style element to remove underlines from all links in this component
      const style = document.createElement('style');
      style.textContent = `
        .add-article-container a, 
        .add-article-container a span, 
        .add-article-container .link,
        .add-article-container .link span {
          text-decoration: none !important;
        }
      `;
      document.head.appendChild(style);
      
      // Clean up the style element when component unmounts
      return () => {
        document.head.removeChild(style);
      };
    }, []);

    // Add cleanup on unmount
    useEffect(() => {
      return () => {
        setIsMounted(false);
      };
    }, []);

    const sendDryrunRequest = () => {
      // setIsLoading(true);
      axios
        .post(process.env.REACT_APP_BACKEND_URL + '/api/upload', {
          article_url: articleUrl,
        })
        .then((res) => {
          console.log(res);
          setIsLoading(false);
          if (res.data.A && res.data.B) {
            console.log('redirecting...');
            // Parset the file name from the url
            const fileName = articleUrl.split('/').pop();
            setRedirectTo(
              `/add/text?type=pdf&title=${fileName}&text=${encodeURIComponent(
                res.data.A
              )}&backupText=${encodeURIComponent(res.data.B)}`
            );
          }
        })
        .catch((e) => {
          setIsLoading(false);
        });

      dryrunArticle(articleUrl, selectionText, idToken)
        .then((res) => {
          if (res.data.is_supported) {
            // if (res.data.estimated_credit_cost < 0.01) {
            //   setEstimate('0');
            // } else {
            //   setEstimate(res.data.estimated_credit_cost);
            // }
          } else {
            setStatus(res.data.reason);
            setButtonMessage('Request Support');
            setEstimate('0');
          }
        })
        .catch((e) => {
          setEstimate('Unavailable');
          setStatus('Something went wrong.');
          console.log(e);
        });
    };

    const redirectOrDryrunOrSend = () => {
      if (isUrl(articleUrl)) {
        if (isSignedIn === false) {
          // TODO: need to add user_id
          // TODO: need to add article url, etc so it starts an onboarding process ixf necessary.
          // TODO: Add redirection
          const params = `?redirected_from=add&url=${encodeURIComponent(
            articleUrl
          )}`;
          history.push(
            trackingId ? `/signin/${trackingId}${params}` : `/signin${params}`
          );
        } else if (isSignedIn === true) {
          // Only auto-submit if shouldForceAdd is true (from URL parameters)
          if (shouldForceAdd) {
            sendArticle();
            setShouldForceAdd(false);
          }
        }
      }
    };

    useEffect(() => {
      console.log('paid user', isPaidUser);
      console.log('pro user', isProUser);
      // TODO: this fires twice for some reason

      redirectOrDryrunOrSend();

      if (
        !isUrl(articleUrl) &&
        articleUrl.length >= 20 &&
        !articleUrl.startsWith('file://') &&
        !articleUrl.startsWith('http') &&
        !articleUrl.endsWith('.rss')
      ) {
        // NOTE: if a user types text in the article URL section
        // or a body of text gets shared on iOS
        // Get the current date
        setRedirectTo(
          `/add/text?type=input_text&title=untitled&text=${encodeURIComponent(articleUrl)}`
        );
      } else if (
        !isUrl(articleUrl) &&
        articleUrl.length > 10 &&
        !articleUrl.startsWith('http') &&
        !articleUrl.endsWith('.rss')
      ) {
        setStatus('Please enter a valid URL');
      } else if (articleUrl.length === 0) {
        setStatus('');
      }
    }, [isSignedIn, articleUrl]);

    useEffect(() => {
      if (articleUrl && isUrl(articleUrl)) {
      }
    }, [articleUrl]);

    useEffect(() => {
      // Hide Intercom
      // update({
      //   hide_default_launcher: true
      // });

      mixpanel.track('Open Add Article');
      const tolt_referral = window.tolt_referral

      // Set Once
      mixpanel.people.set_once({
        utm_source: mixpanel.get_property('utm_source'),
        utm_medium: mixpanel.get_property('utm_medium'),
        utm_campaign: mixpanel.get_property('utm_campaign'),
        utm_term: mixpanel.get_property('utm_term'),
        search_engine: mixpanel.get_property('$search_engine'),
        search_keyword: mixpanel.get_property('mp_keyword'),
        referrer: mixpanel.get_property('$referrer'),
        initial_referrer: mixpanel.get_property('$initial_referrer'),
        tolt_referral: tolt_referral,

      });

      if (shouldForceAdd) {
        setIsLoading(true);
      }
    }, []);

    const normalizeUrl = (url) => {
      if (!url) return url;
      url = url.trim();
      if (!/^https?:\/\//i.test(url)) {
        return `https://${url}`;
      }
      return url;
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      
      // First check if this is text content that should redirect
      if (
        !isUrl(articleUrl) &&
        articleUrl.length >= 20 &&
        !articleUrl.startsWith('file://') &&
        !articleUrl.startsWith('http') &&
        !articleUrl.endsWith('.rss')
      ) {
        // This is likely text content, not a URL - redirect to text page
        setRedirectTo(
          `/add/text?type=input_text&title=untitled&text=${encodeURIComponent(articleUrl)}`
        );
        return;
      }
      
      // Only normalize as URL if we've determined it's not text content
      const normalizedUrl = normalizeUrl(articleUrl);
      setArticleUrl(normalizedUrl);
      handleAddArticle();
    };

    const handleAddArticle = () => {
      if (isUrl(articleUrl)) {
        if (isSignedIn === false) {
          // TODO: need to add user_id
          // TODO: need to add article url, etc so it starts an onboarding process ixf necessary.
          // TODO: Add redirection
          const params = `?redirected_from=add&url=${encodeURIComponent(
            articleUrl
          )}`;
          history.push(
            trackingId ? `/signin/${trackingId}${params}` : `/signin${params}`
          );
        } else if (isSignedIn === true) {
          // sendDryrunRequest();
          sendArticle();
          if (shouldForceAdd) {
            setShouldForceAdd(false);
          }
        }
      }
    };

    // Add this function to check if URL is likely an RSS feed
    const isRssFeedUrl = (url) => {
      return url && (
        url.includes('.xml') || 
        url.includes('rss') || 
        url.includes('/feed') ||
        url.includes('atom')
      );
    };
    
    // Update button text based on URL type
    useEffect(() => {
      if (articleUrl) {
        if (isRssFeedUrl(articleUrl)) {
          setButtonMessage('Add Feed');
        } else {
          setButtonMessage('Add Article');
        }
      } else {
        setButtonMessage('Add Article');
      }
    }, [articleUrl]);

    // Add this function to check monthly conversions
    const checkMonthlyConversions = async () => {
      try {
        const response = await getUserPlaylist(idToken);
        const articles = response || [];
        
        // Get date 30 days ago
        const now = new Date();
        const thirtyDaysAgo = new Date(now.getTime() - (30 * 24 * 60 * 60 * 1000));
        
        console.log('Checking monthly conversions:', {
          totalArticles: articles.length,
          thirtyDaysAgo: thirtyDaysAgo.toISOString(),
          now: now.toISOString()
        });
        
        // Count non-feed articles from last 30 days
        const monthlyConversions = articles.filter(article => {
          const articleDate = new Date(article.date_added);
          const isRecent = articleDate >= thirtyDaysAgo;
          const isNotFeed = !article.feed_id;
          const isNotKeyFeatures = article.article_id !== 'audioread.com/key-features-and-how-tos';
          
          console.log('Article check:', {
            articleId: article.article_id,
            dateAdded: article.date_added,
            articleDate: articleDate.toISOString(),
            isRecent,
            isNotFeed,
            isNotKeyFeatures,
            feedId: article.feed_id
          });
          
          return isNotFeed && isRecent && isNotKeyFeatures;
        }).length;
        
        console.log('Monthly conversions result:', {
          monthlyConversions,
          isPaidUser,
          isProUser
        });
        
        return monthlyConversions;
      } catch (error) {
        console.error('Error checking monthly conversions:', error);
        return 0;
      }
    };

    const sendArticle = (e) => {
      if (e) {
        e.preventDefault();
      }
      
      // Check if URL is a YouTube URL
      const isYoutubeUrl = articleUrl.match(/(?:youtube\.com|youtu\.be)/i);
      if (isYoutubeUrl) {
        setModalContent({
          title: "YouTube Not Supported",
          message: "Sorry, we no longer support YouTube video conversions.",
        });
        showModal();
        setIsLoading(false);
        return;
      }
      
      if (isMounted) {
        setIsLoading(true);
      }
      
      console.log('Sending article:', articleUrl);
      
      const isRssFeed = isRssFeedUrl(articleUrl);
      
      if (isRssFeed) {
        // Check if user is on pro plan
        if (!isProUser) {
          setModalContent({
            title: "Pro Feature",
            message: "Upgrade to pro to add feeds by URLs.",
            actionText: "Upgrade Now",
            actionHandler: () => {
              // Check if user has a customer_id but no active subscription (cancelled)
              const hasStripeCustomerId = userStore.user?.stripe_customer_id || userStore.user?.customer_id;
              const hasActiveSubscription = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id;
              
              if (hasStripeCustomerId && !hasActiveSubscription) {
                // User has cancelled subscription - send to onboarding to reactivate
                window.location.href = '/onboarding/choosevoice';
              } else if (hasStripeCustomerId) {
                // User has active subscription - send to customer portal
                window.location.href = userStore.customerPortalUrl;
              } else {
                // User has no Stripe customer - send to onboarding
                window.location.href = '/onboarding/choosevoice';
              }
              hideModal();
            }
          });
          showModal();
          setIsLoading(false);
          return;
        }

        // Handle as RSS feed
        mixpanel.track('Add RSS Feed', { feed_url: articleUrl });
        console.log('Adding RSS feed:', articleUrl);
        
        // First check if user is already subscribed to this feed
        getUserFeeds(idToken)
          .then((response) => {
            const userFeeds = response.data.feeds || [];
            const isAlreadySubscribed = userFeeds.some(feed => 
              feed.feed_url === articleUrl || 
              feed.feed_url.replace(/\/+$/, '') === articleUrl.replace(/\/+$/, '') // Compare without trailing slashes
            );
            
            if (isAlreadySubscribed) {
              // User is already subscribed to this feed
              setModalContent({
                title: "Already Subscribed",
                message: "You are already subscribed to this feed.",
              });
              showModal();
              setIsLoading(false);
              return;
            }
            
            // User is not subscribed, proceed with adding the feed
            return addUserFeed(idToken, articleUrl)
              .then((res) => {
                console.log('Feed added:', res);
                if (isMounted) {
                  setArticleUrl('');
                  setButtonMessage('Feed Added!');
                  
                  // Show success message
                  setModalContent({
                    title: "Feed Added",
                    message: "Your feed has been added successfully. You'll start receiving new articles from this feed automatically within the next few hours.",
                  });
                  showModal();
                  
                  setTimeout(() => {
                    setButtonMessage('Add Article');
                  }, 3000);
                }
              });
          })
          .catch((err) => {
            console.error('Error adding feed:', err);
            
            // Show error message
            setModalContent({
              title: "Error Adding Feed",
              message: err.response?.data?.message || "There was a problem adding your feed. Please check the URL and try again.",
            });
            showModal();
          })
          .finally(() => {
            if (isMounted) {
              setIsLoading(false);
            }
          });
      } else {
        // Handle as regular article
        mixpanel.track('Add Article at /add', { article_url: articleUrl });
        
        // Check monthly conversions for unpaid users
        if (!isPaidUser) {
          checkMonthlyConversions().then(conversions => {
            if (conversions >= 4) {
              setModalContent({
                title: "Limit Reached",
                message: "You've reached your limit of 3 article conversions in the last 30 days. Upgrade to a paid plan for unlimited conversions.",
                actionText: "Upgrade Now",
                actionHandler: () => {
                  // Check if user has a customer_id but no active subscription (cancelled)
                  const hasStripeCustomerId = userStore.user?.stripe_customer_id || userStore.user?.customer_id;
                  const hasActiveSubscription = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id;
                  
                  if (hasStripeCustomerId && !hasActiveSubscription) {
                    // User has cancelled subscription - send to onboarding to reactivate
                    window.location.href = '/onboarding/choosevoice';
                  } else if (hasStripeCustomerId) {
                    // User has active subscription - send to customer portal
                    window.location.href = userStore.customerPortalUrl;
                  } else {
                    // User has no Stripe customer - send to onboarding
                    window.location.href = '/onboarding/choosevoice';
                  }
                  hideModal();
                }
              });
              showModal();
              setIsLoading(false);
              return;
            }
            
            // Proceed with article conversion
            proceedWithArticleConversion();
          });
        } else {
          // Paid users can proceed directly
          proceedWithArticleConversion();
        }
      }
    };

    const proceedWithArticleConversion = () => {
      // Set a timeout to redirect after 3 seconds if no error occurs
      const redirectTimer = setTimeout(() => {
        if (isMounted) {
          setArticleUrl('');
          window.location.href = '/playlist';
        }
      }, 3000);
      
      addArticleToUserPlaylist(
        {
          title: '',
          article_url: articleUrl, 
          type: '',
          text: '',
          tldr: addTldr,
        },
        idToken,
        '/add',
      )
        .then((res) => {
          console.log(res);
          // Clear the redirect timer since we got a response
          clearTimeout(redirectTimer);
          if (isMounted) {
            setArticleUrl('');
            window.location.href = '/playlist';
          }
        })
        .catch((err) => {
          console.log(err);
          // Clear the redirect timer since we got an error
          clearTimeout(redirectTimer);
          if (isMounted) {
            setIsLoading(false);
          }
        });
    };

    const handleTldrClick = () => {
      if (isProUser) {
        setAddTldr(!addTldr);
        updateUserTldrPreference(user.user_id, !addTldr)
          .then(response => {
            console.log('User record updated:', response.data);
          })
          .catch(error => {
            console.error('Error updating user record:', error);
          });
      } else {
        // Show modal for non-pro users
        setModalContent({
          title: "Pro Feature", 
          message: "Upgrade to pro to use the summary feature.",
          actionText: "Upgrade Now",
          actionHandler: () => {
            // Check if user has a customer_id but no active subscription (cancelled)
            const hasStripeCustomerId = userStore.user?.stripe_customer_id || userStore.user?.customer_id;
            const hasActiveSubscription = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id;
            
            if (hasStripeCustomerId && !hasActiveSubscription) {
              // User has cancelled subscription - send to onboarding to reactivate
              window.location.href = '/onboarding/choosevoice';
            } else if (hasStripeCustomerId) {
              // User has active subscription - send to customer portal
              window.location.href = userStore.customerPortalUrl;
            } else {
              // User has no Stripe customer - send to onboarding
              window.location.href = '/onboarding/choosevoice';
            }
            hideModal();
          }
        });
        showModal();
      }
    };

    // Add a new function to handle text input changes
    const handleInputChange = (e) => {
      try {
        const value = e.target.value;
        
        // Always update the input value first
        setArticleUrl(value);
        
        // Only redirect for longer text content after a small delay
        if (value.length >= 50 && 
            !isUrl(value) && 
            !value.startsWith('http') && 
            !value.startsWith('file://')) {
          
          // Use setTimeout to avoid immediate state updates
          const timeoutId = setTimeout(() => {
            try {
              if (isMounted) {
                window.location.href = `/add/text?type=input_text&title=untitled&text=${encodeURIComponent(value)}`;
              }
            } catch (err) {
              console.error('Error redirecting to text page:', err);
              // Fallback - clear input and show error
              if (isMounted) {
                setArticleUrl('');
                setStatus('Error processing text input. Please try again.');
              }
            }
          }, 100);

          // Cleanup timeout on unmount
          return () => clearTimeout(timeoutId);
        }
      } catch (err) {
        console.error('Error in handleInputChange:', err);
        if (isMounted) {
          setArticleUrl('');
          setStatus('Error processing input. Please try again.');
        }
      }
    };

    if (redirectTo) {
      window.location.href = redirectTo;
      return null;
    }

    // useEffect(() => {
    //   Intercom({
    //     app_id: "fduylg2r", 
    //     hide_default_launcher: false,
    //     mobile: true,
    //   });
    // }, []);

    // Track basic plan conversion
    useEffect(() => {
      const subscription = userStore.user?.subscriptions?.raw_subscriptions?.[0];
      if (subscription) {
        if (isProUser) {
          console.log('Tracking pro plan conversion');
          // Google Analytics tracking
          window.gtag('event', 'conversion', {
            'send_to': 'AW-16989360809/y69hCO-NzLYaEKmllKU_',
            'value': 100.0,
            'currency': 'USD',
            'transaction_id': subscription.id || '',
          });
          // Mixpanel tracking for verification
          mixpanel.track('Google Conversion', {
            user_email: userStore.user?.email,
            subscription_id: subscription.id,
            plan: 'pro',
            value: 100.0,
            currency: 'USD',
            google_conversion_id: 'AW-16989360809/y69hCO-NzLYaEKmllKU_'
          });
        } else {
          console.log('Tracking basic plan conversion');
          // Google Analytics tracking
          window.gtag('event', 'conversion', {
            'send_to': 'AW-16989360809/dsGWCOyNzLYaEKmllKU_',
            'value': 30.0,
            'currency': 'USD',
            'transaction_id': subscription.id || '',
          });
          // Mixpanel tracking for verification
          mixpanel.track('Google Conversion', {
            user_email: userStore.user?.email,
            subscription_id: subscription.id,
            plan: 'basic',
            value: 30.0,
            currency: 'USD',
            google_conversion_id: 'AW-16989360809/dsGWCOyNzLYaEKmllKU_'
          });
        }
      }
    }, [userStore.user?.subscriptions?.raw_subscriptions, isProUser]);

    return (
      <div className="add-article-container">
        <Modal
          isOpen={isModalOpen && !isLoading}
          onDismiss={hideModal}
          isBlocking={false}
          isDarkOverlay={true}
          containerClassName={contentStyles.container}
        >
          <div>
            {modalContent ? (
              <>
                <div style={{ color: 'white', marginBottom: '15px', fontWeight: 'bold' }}>
                  {modalContent.title}
                </div>
                <div style={{ color: 'white', marginBottom: '15px' }}>
                  {modalContent.message}
                </div>
                {modalContent.actionText && (
                  <button
                    onClick={modalContent.actionHandler}
                    className="clickable"
                    style={{
                      backgroundColor: '#1976d2',
                      border: 'none',
                      color: 'white',
                      borderRadius: '9px',
                      marginTop: '14px',
                      marginRight: '10px',
                      fontSize: '16px',
                      padding: '8px 16px',
                      outline: 'none',
                      cursor: 'pointer',
                    }}
                  >
                    {modalContent.actionText}
                  </button>
                )}
                <button
                  onClick={hideModal}
                  className="clickable"
                  style={{
                    backgroundColor: 'transparent',
                    border: '1px solid lightgrey',
                    color: 'white',
                    borderRadius: '9px',
                    marginTop: '14px',
                    fontSize: '16px',
                    padding: '2px 8px',
                    outline: 'none',
                  }}
                >
                  Close
                </button>
              </>
            ) : (
              <>
                <div style={{ color: 'white' }}>
                  {articleUrl && user && user.user_id && isSupportedType(articleUrl, user.user_id)}
                </div>
                <div>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      hideModal();
                    }}
                    className="clickable"
                    style={{
                      backgroundColor: 'transparent',
                      border: 'none',
                      color: 'white',
                      borderRadius: '9px',
                      border: '1px solid lightgrey',
                      marginTop: '14px',
                      fontSize: '16px',
                      padding: '2px 8px',
                      outline: 'none',
                    }}
                  >
                    Close
                  </button>
                </div>
              </>
            )}
          </div>
        </Modal>
        <div
          style={{
            width: '257px',
            display: 'flex',
            justifyContent: 'space-between',
            position: 'relative',
          }}
        >
          <Link
            className="input-button"
            to="/add/text?type=input_text"
            style={{
              width: '124px',
              marginBottom: '10px',
              borderColor: '#dddddda1',
            }}
          >
            Paste Text
          </Link>
          <div
            style={{
              width: '124px',
              marginBottom: '10px',
              position: 'relative',
            }}
          >
            <Upload />
          </div>
        </div>

        <form
          className="search"
          onSubmit={handleSubmit}
        >
          <Plus />
          <input
            autoFocus={!isMobile}
            type="url"
            placeholder="Article or Feed URL"
            value={articleUrl}
            onChange={handleInputChange}
            style={{ borderColor: '#dddddda1' }}
          />
        </form>

        <div className="confirm">
          <button
            type="submit"
            className="add-to-playlist"
            onClick={handleAddArticle}
            style={{
              transition: 'all 0.2s ease-in-out',
              backgroundColor: '#1976d2',
              color: 'white',
              border: 'none',
              borderRadius: '9px',
              padding: '10px 20px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: '500',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.backgroundColor = '#1565c0';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(25, 118, 210, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.backgroundColor = '#1976d2';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            {isLoading ? (
              <img
                src={loadingIcon}
                style={{ height: '25px' }}
                alt="loading..."
              />
            ) : (
              <span>{buttonMessage}</span>
            )}
          </button>
        </div>
        <div className="status">{status}</div>

        {/* <Checkout /> */}
        {app && app === 'chrome' && (
          <>
            <div style={{ marginTop: '15px', opacity: '0.8' }}>
              Change shorcuts at chrome://extensions/shortcuts
            </div>
          </>
        )}
        <div style={{ display: 'none' }}>
          <h3>How To...</h3>
          <div>Send content from a mobile device</div>
          <div>Listen in a podcast app</div>
          <div>Change the shortcuts</div>
          <div>Send private/paywalled content</div>
          <div>Convert emails</div>
        </div>

        <div
          className="add-article-app-links"
          style={{ paddingBottom: '150px' }}
        >
          <a href="https://audioread.tolt.io/" target="_blank" style={{
            cursor: 'pointer',
          }}>
            <span></span>
          </a>

          <Tooltip 
            title={
              isProUser 
                ? "Add a summary to the beginning of your articles"
                : <a href={userStore.customerPortalUrl} style={{ color: '#fff', textDecoration: 'underline' }}>Add a summary to the beginning of your articles. Upgrade to pro to use this feature</a>
            }
            placement="top"
          >
            <div 
              className="small-transparent-button" 
              style={{ 
                width: '257px', 
                marginBottom: '10px',
                transition: 'transform 0.2s ease-in-out',
                cursor: 'pointer'
              }}
              onClick={handleTldrClick}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              <div className="content" style={{ justifyContent: 'center', display: 'flex', alignItems: 'center' }}>
                <Switch
                  checked={addTldr}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleTldrClick();
                  }}
                  color="primary"
                  name="addTldr"
                  inputProps={{ 'aria-label': 'Add TLDR' }}
                  sx={{
                    marginRight: '10px',
                    '& .MuiSwitch-switchBase': {
                      '&.Mui-checked': {
                        color: '#fff',
                        '& + .MuiSwitch-track': {
                          backgroundColor: '#1976d2',
                        },
                      },
                    },
                    '& .MuiSwitch-track': {
                      backgroundColor: '#757575',
                    },
                  }}
                />
                <label style={{ fontWeight: 'bold', marginLeft: '-10px' }}>Add Summary</label>
              </div>
            </div>
          </Tooltip>

          <div 
            className="small-transparent-button" 
            style={{ 
              width: '257px',
              transition: 'transform 0.2s ease-in-out',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            <Link
              className="link"
              to={`/preferredVoices`}
              style={{ width: '100%', height: '100%', display: 'block', textDecoration: 'none' }}
            >
              <div className="content" style={{ justifyContent: "center" }}>
                <RecordVoiceOverIcon style={{ marginRight: '5px' }} />
                <span style={{ textDecoration: 'none' }}>Choose Voice</span>
              </div>
            </Link>
          </div>
          
          {userFeedUrl && (
            <div 
              className="small-transparent-button" 
              style={{ 
                width: '257px',
                transition: 'transform 0.2s ease-in-out',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              <Link
                className="link"
                to={`/setupnew?feed_url=${encodeURIComponent(userFeedUrl)}`}
                style={{ width: '100%', height: '100%', display: 'block' }}
              >
                <div className="content" style={{ justifyContent: "center" }}>
                  <RssFeedIcon />
                  <span>Connect Podcast App</span>
                </div>
              </Link>
            </div>
          )}

          <div 
            className="small-transparent-button" 
            style={{ 
              width: '257px',
              transition: 'transform 0.2s ease-in-out',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            <a
              href="https://chrome.google.com/webstore/detail/audiblogs-send-as-podcast/fblchjbbkkaoobkhhbloehgkpdlomido"
              target="_blank"
              style={{ width: '100%', height: '100%', display: 'block' }}
            >
              <div className="content" style={{ justifyContent: "center" }}>
                <img src={Chrome} />
                <span>Setup on Browser</span>
              </div>
            </a>
          </div>

          <div 
            className="small-transparent-button" 
            style={{ 
              width: '257px',
              transition: 'transform 0.2s ease-in-out',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            <Link 
              className="link" 
              to={`/onboarding/ios`}
              style={{ width: '100%', height: '100%', display: 'block' }}
            >
              <div className="content" style={{ justifyContent: "center" }}>
                <AppleIcon className="icon"></AppleIcon>
                <span>Setup on Apple</span>
              </div>
            </Link>
          </div>

          <div 
            className="small-transparent-button" 
            style={{ 
              width: '257px',
              transition: 'transform 0.2s ease-in-out',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            <a
              href="/onboarding/android"
              target="_blank"
              style={{ width: '100%', height: '100%', display: 'block' }}
            >
              <div className="content" style={{ justifyContent: "center" }}>
                <AndroidIcon className="icon"></AndroidIcon>
                <span>Setup on Android</span>
              </div>
            </a>
          </div>

          <div 
            className="small-transparent-button" 
            style={{ 
              width: '257px',
              transition: 'transform 0.2s ease-in-out',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            <a
              onClick={(e) => {
                e.preventDefault();
                setShowEmail(true);
                const emailAddress = `user-${user.user_id}@email.audioread.com`;
                navigator.clipboard.writeText(emailAddress);
                // Show notification
                const notification = document.createElement('div');
                notification.textContent = 'Email address copied to clipboard!';
                notification.style.position = 'fixed';
                notification.style.top = `${e.clientY - 40}px`; // Position above cursor
                notification.style.left = '50%';
                notification.style.transform = 'translateX(-50%)';
                notification.style.backgroundColor = '#1976d2';
                notification.style.color = 'white';
                notification.style.padding = '10px 20px';
                notification.style.borderRadius = '5px';
                notification.style.zIndex = '1000';
                document.body.appendChild(notification);
                setTimeout(() => {
                  notification.remove();
                }, 3000);
              }}
              style={{ width: '100%', height: '100%', display: 'block' }}
            >
              <div className="content" style={{ justifyContent: "center", cursor: "pointer" }}>
                <ForwardToInboxIcon className="icon"></ForwardToInboxIcon>
                <span>Listen to Emails</span>
              </div>
            </a>
          </div>

          <div style={{ textAlign: 'center' }}>
            {user && user.user_id && showEmail && (<>
              {`Forward emails to `} <a href={`mailto:user-${user.user_id}@email.audioread.com`}>user-{user.user_id}@email.audioread.com</a>
            </>)}
          </div>

          <div 
            className="small-transparent-button" 
            style={{ 
              width: '257px',
              transition: 'transform 0.2s ease-in-out',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            <a 
              href="https://audioread.tolt.io/" 
              target="_blank"
              style={{ width: '100%', height: '100%', display: 'block' }}
            >
              <div className="content" style={{ justifyContent: "center" }}>
                <PaidIcon style={{ marginRight: '5px' }} />
                <span>Earn Lifetime Commission</span>
              </div>
            </a>
          </div>

          <div 
            className="small-transparent-button" 
            style={{ 
              width: '257px',
              transition: 'transform 0.2s ease-in-out',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            <a 
              href="" 
              onClick={(e) => { e.preventDefault(); window.Intercom('show'); }}
              style={{ width: '100%', height: '100%', display: 'block' }}
            >
              <div className="content" style={{ justifyContent: "center", cursor: "pointer" }}>
                <SupportAgentIcon className="icon"></SupportAgentIcon>
                <span>Contact Support</span>
              </div>
            </a>
          </div>

          <div id="audioread-hotjar-feedback"></div>
        </div>

      </div>
    );
  }
);

export default AddArticle;
